"use strict";
/* eslint-disable max-lines */
Object.defineProperty(exports, "__esModule", { value: true });
exports.englishUsSuperScrabble = exports.englishUsScrabbleDuel = exports.englishUsScrabble = exports.englishUsLiteraki = exports.englishUsLetterLeague = exports.englishGbSuperScrabble = exports.englishGbScrabbleDuel = exports.englishGbScrabble = exports.englishGbLiteraki = exports.englishGbLetterLeague = void 0;
const types_1 = require("@scrabble-solver/types");
const games_1 = require("../games");
exports.englishGbLetterLeague = new types_1.Config({
    ...games_1.letterLeague,
    locale: types_1.Locale.EN_GB,
    tiles: [
        { character: 'a', score: 1 },
        { character: 'b', score: 3 },
        { character: 'c', score: 3 },
        { character: 'd', score: 2 },
        { character: 'e', score: 1 },
        { character: 'f', score: 4 },
        { character: 'g', score: 2 },
        { character: 'h', score: 4 },
        { character: 'i', score: 1 },
        { character: 'j', score: 8 },
        { character: 'k', score: 5 },
        { character: 'l', score: 2 },
        { character: 'm', score: 3 },
        { character: 'n', score: 1 },
        { character: 'o', score: 1 },
        { character: 'p', score: 3 },
        { character: 'q', score: 10 },
        { character: 'r', score: 1 },
        { character: 's', score: 1 },
        { character: 't', score: 1 },
        { character: 'u', score: 1 },
        { character: 'v', score: 4 },
        { character: 'w', score: 4 },
        { character: 'x', score: 8 },
        { character: 'y', score: 4 },
        { character: 'z', score: 10 },
    ],
});
exports.englishGbLiteraki = new types_1.Config({
    ...games_1.literaki,
    locale: types_1.Locale.EN_GB,
    name: 'Literaxx',
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishGbScrabble = new types_1.Config({
    ...games_1.scrabble,
    locale: types_1.Locale.EN_GB,
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishGbScrabbleDuel = new types_1.Config({
    ...games_1.scrabbleDuel,
    locale: types_1.Locale.EN_GB,
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishGbSuperScrabble = new types_1.Config({
    ...games_1.superScrabble,
    locale: types_1.Locale.EN_GB,
    tiles: [
        { character: 'a', count: 16, score: 1 },
        { character: 'b', count: 4, score: 3 },
        { character: 'c', count: 6, score: 3 },
        { character: 'd', count: 8, score: 2 },
        { character: 'e', count: 24, score: 1 },
        { character: 'f', count: 4, score: 4 },
        { character: 'g', count: 5, score: 2 },
        { character: 'h', count: 5, score: 4 },
        { character: 'i', count: 13, score: 1 },
        { character: 'j', count: 2, score: 8 },
        { character: 'k', count: 2, score: 5 },
        { character: 'l', count: 7, score: 1 },
        { character: 'm', count: 6, score: 3 },
        { character: 'n', count: 13, score: 1 },
        { character: 'o', count: 15, score: 1 },
        { character: 'p', count: 4, score: 3 },
        { character: 'q', count: 2, score: 10 },
        { character: 'r', count: 13, score: 1 },
        { character: 's', count: 10, score: 1 },
        { character: 't', count: 15, score: 1 },
        { character: 'u', count: 7, score: 1 },
        { character: 'v', count: 3, score: 4 },
        { character: 'w', count: 4, score: 4 },
        { character: 'x', count: 2, score: 8 },
        { character: 'y', count: 4, score: 4 },
        { character: 'z', count: 2, score: 10 },
    ],
});
exports.englishUsLetterLeague = new types_1.Config({
    ...games_1.letterLeague,
    locale: types_1.Locale.EN_US,
    tiles: [
        { character: 'a', score: 1 },
        { character: 'b', score: 3 },
        { character: 'c', score: 3 },
        { character: 'd', score: 2 },
        { character: 'e', score: 1 },
        { character: 'f', score: 4 },
        { character: 'g', score: 2 },
        { character: 'h', score: 4 },
        { character: 'i', score: 1 },
        { character: 'j', score: 8 },
        { character: 'k', score: 5 },
        { character: 'l', score: 2 },
        { character: 'm', score: 3 },
        { character: 'n', score: 1 },
        { character: 'o', score: 1 },
        { character: 'p', score: 3 },
        { character: 'q', score: 10 },
        { character: 'r', score: 1 },
        { character: 's', score: 1 },
        { character: 't', score: 1 },
        { character: 'u', score: 1 },
        { character: 'v', score: 4 },
        { character: 'w', score: 4 },
        { character: 'x', score: 8 },
        { character: 'y', score: 4 },
        { character: 'z', score: 10 },
    ],
});
exports.englishUsLiteraki = new types_1.Config({
    ...games_1.literaki,
    locale: types_1.Locale.EN_US,
    name: 'Literaxx',
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishUsScrabble = new types_1.Config({
    ...games_1.scrabble,
    locale: types_1.Locale.EN_US,
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishUsScrabbleDuel = new types_1.Config({
    ...games_1.scrabbleDuel,
    locale: types_1.Locale.EN_US,
    tiles: [
        { character: 'a', count: 9, score: 1 },
        { character: 'b', count: 2, score: 3 },
        { character: 'c', count: 2, score: 3 },
        { character: 'd', count: 4, score: 2 },
        { character: 'e', count: 12, score: 1 },
        { character: 'f', count: 2, score: 4 },
        { character: 'g', count: 3, score: 2 },
        { character: 'h', count: 2, score: 4 },
        { character: 'i', count: 9, score: 1 },
        { character: 'j', count: 1, score: 8 },
        { character: 'k', count: 1, score: 5 },
        { character: 'l', count: 4, score: 1 },
        { character: 'm', count: 2, score: 3 },
        { character: 'n', count: 6, score: 1 },
        { character: 'o', count: 8, score: 1 },
        { character: 'p', count: 2, score: 3 },
        { character: 'q', count: 1, score: 10 },
        { character: 'r', count: 6, score: 1 },
        { character: 's', count: 4, score: 1 },
        { character: 't', count: 6, score: 1 },
        { character: 'u', count: 4, score: 1 },
        { character: 'v', count: 2, score: 4 },
        { character: 'w', count: 2, score: 4 },
        { character: 'x', count: 1, score: 8 },
        { character: 'y', count: 2, score: 4 },
        { character: 'z', count: 1, score: 10 },
    ],
});
exports.englishUsSuperScrabble = new types_1.Config({
    ...games_1.superScrabble,
    locale: types_1.Locale.EN_US,
    tiles: [
        { character: 'a', count: 16, score: 1 },
        { character: 'b', count: 4, score: 3 },
        { character: 'c', count: 6, score: 3 },
        { character: 'd', count: 8, score: 2 },
        { character: 'e', count: 24, score: 1 },
        { character: 'f', count: 4, score: 4 },
        { character: 'g', count: 5, score: 2 },
        { character: 'h', count: 5, score: 4 },
        { character: 'i', count: 13, score: 1 },
        { character: 'j', count: 2, score: 8 },
        { character: 'k', count: 2, score: 5 },
        { character: 'l', count: 7, score: 1 },
        { character: 'm', count: 6, score: 3 },
        { character: 'n', count: 13, score: 1 },
        { character: 'o', count: 15, score: 1 },
        { character: 'p', count: 4, score: 3 },
        { character: 'q', count: 2, score: 10 },
        { character: 'r', count: 13, score: 1 },
        { character: 's', count: 10, score: 1 },
        { character: 't', count: 15, score: 1 },
        { character: 'u', count: 7, score: 1 },
        { character: 'v', count: 3, score: 4 },
        { character: 'w', count: 4, score: 4 },
        { character: 'x', count: 2, score: 8 },
        { character: 'y', count: 4, score: 4 },
        { character: 'z', count: 2, score: 10 },
    ],
});
